import { render, staticRenderFns } from "./Reg_wxgz.vue?vue&type=template&id=2b4d1ec4&scoped=true"
import script from "./Reg_wxgz.vue?vue&type=script&lang=js"
export * from "./Reg_wxgz.vue?vue&type=script&lang=js"
import style0 from "./Reg_wxgz.vue?vue&type=style&index=0&id=2b4d1ec4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d1ec4",
  null
  
)

export default component.exports